import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import HomePage from "./pages/home";
import ProductPage from "./pages/product";
import {create} from 'jss';
import rtl from 'jss-rtl';
import {jssPreset, StylesProvider} from '@mui/styles';
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import {createTheme} from "@mui/material";
import '../node_modules/react-vis/dist/style.css';


// Configure JSS
const jss = create({
    plugins: [...jssPreset().plugins, rtl()],
});
const theme = createTheme({
    direction: 'rtl',
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <StylesProvider jss={jss}>
                <Router>
                    <Routes>
                        <Route path='/products/:id'  element={<ProductPage/>}/>
                        <Route path='/' element={<HomePage/>}/>
                    </Routes>
                </Router>
            </StylesProvider>
        </ThemeProvider>
    );
}

export default App;
